/**
 * Standing shift patterns from the 1.1 sketch. Used to seed availability rules
 * in the demo tenant (Phase A seed) and to build test snapshots; the real shifts
 * the product generates from those rules are what the screens read.
 * Weekdays are ISO (1 = Monday … 7 = Sunday). Times are branch-zone wall clock.
 */
export interface StandingPattern {
  weekdays: number[];
  start: string;
  end: string;
  /** Weekdays on which the shift is an overflow (on-call) shift. */
  overflowWeekdays?: number[];
  /** Per-diem: declared-available days only; anything else is undeclared. */
  perDiem?: boolean;
}

export const STANDING_PATTERNS: Record<string, StandingPattern> = {
  dana: { weekdays: [1, 2, 3, 4, 5], start: "08:00", end: "17:00" },
  // Six days with the weekend rotation on Saturday. Every act that needs Marcus needs him on a weekday
  // (today, or the next working day for Okafor's conversion in 1.4), so his plain days are Mon–Fri.
  marcus: { weekdays: [1, 2, 3, 4, 5, 6], start: "08:00", end: "17:00", overflowWeekdays: [6] },
  priya: { weekdays: [1, 2, 3, 4, 5], start: "08:00", end: "17:00" },
  devon: { weekdays: [6, 7], start: "08:00", end: "17:00", overflowWeekdays: [7], perDiem: true },
  luis: { weekdays: [1, 2, 3, 4, 5], start: "08:00", end: "17:00" },
  kim: { weekdays: [1, 3, 5], start: "08:00", end: "14:00" },
  ana: { weekdays: [1, 2, 3, 4, 5], start: "08:00", end: "17:00" },
  sam: { weekdays: [2, 4], start: "08:00", end: "17:00" },
  rachel: { weekdays: [1, 2, 3, 4, 5], start: "08:00", end: "17:00" },
  jordan: { weekdays: [2], start: "08:00", end: "17:00", perDiem: true },
  elena: { weekdays: [1, 4], start: "08:00", end: "17:00" },
  tasha: { weekdays: [1, 2, 3, 4, 5], start: "08:00", end: "16:00" },
};
